import React from 'react';
import BaseModal from '../baseModal';

//Import Style
import './style.scss';
import { stacksExplorer, stacksExplorerParam } from '../../lib/constants';

const ConfirmModal = ({ show, setShow, txId, close, closePrevModal, userSettings }) => {
  if (typeof closePrevModal === 'function') {
    closePrevModal();
  }
  return (
    <BaseModal show={show} setShow={setShow} handleClose={close}>
      <p id="transaction-id" className="broadcast-modal-tx">Transaction ID: {`${String(txId).substring(0, 5)}...${String(txId).substring(txId.length - 5)}`}</p>
      <div id="view-tx-btn" className="broadcast-modal-tx__buttons">
        <button className="button" onClick={() => window.open(`${userSettings?.stacksExplorer || stacksExplorer}/txid/${txId}${stacksExplorerParam}`, "_blank")}>View</button>
      </div>
    </BaseModal>
  )
}

export default ConfirmModal;